export const getSortedDelegations = (delegations: any[] = []) => {
  const activeUsers: any[] = [];
  const inactiveUsers: any[] = [];

  delegations.forEach((delegation) => {
    if (delegation.is_active) activeUsers.push(delegation);
    else inactiveUsers.push(delegation);
  });

  const sortByName = (a: any, b: any) =>
    `${a.first_name || ""} ${a.last_name || ""}`.localeCompare(
      `${b.first_name || ""} ${b.last_name || ""}`,
    );

  activeUsers.sort(sortByName);
  inactiveUsers.sort(sortByName);

  return [...activeUsers, ...inactiveUsers];
};
